import * as request from "request-promise-native";
import {TelemetryData} from "./models/TelemetryData";

export class Telemetry {
    public static async send(data: TelemetryData) {
        return request.post('https://katamari.kanareader.com', {
            body: data,
            json: true,
            headers : {
                "content-type": "application/json",
            },
        }).catch(function(p) {
            console.error("p: " + p);
        });
    }
}


// WEBPACK FOOTER //
// ./src/Telemetry.ts